export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ContentSlider.vue?vue&type=template&id=79aed182"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ContentSlider.vue?vue&type=template&id=79aed182
// module id = 94
// module chunks = 0